var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHommeExplique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229,
    height: 210,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M196.948 43.856c1.592-4.612.954-7.14 0-8.61-1.329-2.052-4.374-3.753-9.995-7.894-.367-.27-1.003-.755-.922-1.02.198-.659 3.258-.318 5.919 1.02 3.859 1.94 4.663 2.089 6.956 2.774 4.053 1.214 7.617.2 13.034-1.34a46.156 46.156 0 0 0 8.924-3.588s3.926-1.794 4.997 0l-5.711 2.87s4.997-2.152 7.854-.717l-9.996 4.305s7.497-2.152 7.854-.717c-4.872 3.493-9.169 4.685-12.494 5.022-5.116.52-8.968-.88-10.352 1.076-1.117 1.58.043 4.398 1.429 6.816h-7.497v.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M129.838 77.581c4.453-6.704 9.922-10.721 13.882-13.144a46.963 46.963 0 0 1 6.133 3.284c7.232 4.594 8.028 7.902 14.165 11.733 3.255 2.032 7.287 4.548 12.463 4.205 5.959-.395 10.042-4.354 11.739-5.999 11.643-11.286 7.088-32.667 6.587-34.88l13.207-.359c2.316 4.082 15.079 30.11 5.711 56.33-13.414 37.551-67.984 37.875-84.482 20.588-9.825-10.295-9.768-26.154.595-41.756v-.002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M45.153 189.657c-1.489-2.123-4.111-6.52-6.128-12.244-5.453-15.477-2.491-29.365-1.756-33.3 2.311-12.38 2.79-34.519-3.886-77.123-.8-5.12 2.566-9.945 7.621-10.964 14.019-2.827 32.08-3.943 53.533-1.95 20.064 1.863 37.062 5.763 49.183 10.36.318 22.297-1.48 39.981-3.154 51.912-2.682 19.121-5.295 25.224-5.601 41.573-.46 24.602 5.133 28.069.87 35.7-12.251 21.931-73.598 20.42-90.683-3.964Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M86.118 26.974c-.727 6.936-.888 13.166-1.614 20.102-.196 1.88-3.88 6-6.02 6 0 0 2.007 7 12.04 7 9.03 0 12.04-5 12.04-5-3.01-2-4.013-3-4.013-3-2.007-2-2.007-4.43-2.007-5-.501-4.283.575-7.547.073-11.83L86.12 26.972l-.001.002Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M82.102 29.746c4.534 10.459 15.88 19.113 21.744 16.546 5.864-2.568 5.239-15.577.706-26.036C100.017 9.798 91.333 5.81 85.471 8.378c-5.864 2.568-7.903 10.91-3.368 21.367l-.001.001Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M89.727 28.798c-.572.43-2.805-2.646-4.042-2.097-1.044.464-1.327 3.485-.06 5.556 1.076 1.764 2.511 1.587 2.929 2.963.687 2.262-2.31 5.64-3.432 5.243-.72-.255-.123-1.87-.821-3.715-1.375-3.627-5.887-3.21-9.57-5.983-5.793-4.363-7.372-14.985-3.918-18.963 1.313-1.51 2.785-1.41 4.569-3.843 1.931-2.635 1.088-3.957 2.574-5.652C80.478-.568 86.013-.3 89.51.762c4.4 1.337 4.72 3.671 7.666 3.498 3.488-.204 3.991-3.532 8.15-4.144.24-.036 4.123-.546 7.047 1.992 3.797 3.296 2.868 9.035 2.737 9.849-.843 5.2-5.065 9.888-9.736 10.943-.984.222-.785.011-10.676-.229-3.269-.078-5.243-.103-5.901 1.052-.95 1.669 1.504 4.64.928 5.075h.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M37.364 94.822c5.25 2.394 8.08 5.428 9.7 8.223 6.175 10.663-3.326 21.116 3.496 34.448 4.695 9.175 10.918 7.592 13.989 16.169 3.94 11.003-4.635 18.259-4.197 29.526.22 5.682 2.752 12.778 11.33 20.888-11.26-3.123-21.048-8.534-26.435-16.223-1.488-2.124-4.11-6.521-6.127-12.244-5.454-15.478-2.491-29.366-1.756-33.301 1.702-9.115 2.408-23.521 0-47.487v.001Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M21.837 198.671C3.19 190.491 1.503 159.011.625 142.793c-.69-12.751-3.59-66.308 26.659-82.278 5.28-2.787 10.367-3.796 14.1-4.187 3.632 2.047 12.74 7.852 16.322 18.8 2.03 6.201 1.717 12.316-.336 20.65-5.313 21.564-14.332 25.699-19.417 40.003-10.344 29.099 11.545 53.86.856 63.02-5.532 4.741-16.015.289-16.972-.131v.001Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M96.544 59.075c.178 3.838-1.564 7.943-4.396 9.326-1.806.88-3.578.706-4.504.533-1.715-3.287-1.425-6.572-3.14-9.859 2.007 1 2.05.883 4.013 1 2.894.17 4.014 0 8.027-1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M92.653 67.075s5.318 60.592 23.957 70.292c-.478 1.94 0 17.704 0 17.704s-17.375-5.31-18.366-4.958c-.99.351-21.043-33.381-10.868-81.861l5.277-1.177Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 209.735,
    x2: 157.931,
    y1: 21.886,
    y2: 115.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 173.605,
    x2: 124.654,
    y1: 83.842,
    y2: 186.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 109.341,
    x2: 157.793,
    y1: 159.416,
    y2: 261.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 98.488,
    x2: 41.298,
    y1: 72.383,
    y2: -22.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 102.359,
    x2: 58.418,
    y1: 41.443,
    y2: -37.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 77.099,
    x2: 101.97,
    y1: -12.211,
    y2: 31.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#753519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#320C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 77.851,
    x2: -19.971,
    y1: 230.194,
    y2: -23.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 61.257,
    x2: 114.163,
    y1: 183.781,
    y2: 284.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6064D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 91.37,
    x2: 88.097,
    y1: 32.113,
    y2: 78.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 100.557,
    x2: 100.557,
    y1: 125.394,
    y2: 18.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHommeExplique);
export default __webpack_public_path__ + "static/media/hommeExplique.53cb975b82bcdc511bc62aabd102241a.svg";
export { ForwardRef as ReactComponent };